import { useSelector } from "react-redux";

import { useString } from "../localization/localizationHelpers";
import { OnboardingErrorMessage } from "../models/errors";
import { getCurrentError } from "../redux/selectors";

export const useCurrentErrorMessage = () => {
  const currentError = useSelector(getCurrentError);
  const message = useString(currentError?.message ?? OnboardingErrorMessage.default);
  return message;
};
